import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`One of my favorite mapping together with spherical, parabolic mapping etc....`}</p>
    <h1>{`Preword`}</h1>
    <p>{`Skybox and cubemap etc. can be expensive. Here's one of my tricks to use just one single texture to achieve similar env mapping.`}</p>
    <h1>{`Content`}</h1>
    <p>{`在研读PRT相关文献时，一开始不知道球面均匀分布的坐标如何产生，看到公式，倍感好奇，求之良久`}</p>
    <p>{`发现原来就是一个类似地图的映射：画图如下，`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "244px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3410f44416fdf2c7199785b649b8784c/603fe/mapping-sphere-cylinder.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "85.33333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAARABQDASIAAhEBAxEB/8QAGQABAAIDAAAAAAAAAAAAAAAAAAIFAQME/8QAFwEBAQEBAAAAAAAAAAAAAAAAAAECA//aAAwDAQACEAMQAAABtIS03nYq831QJcg//8QAGxAAAwACAwAAAAAAAAAAAAAAAQIDETEABBP/2gAIAQEAAQUCoHd7eqoM4oXEuw9FEXoU42hr/8QAGREAAgMBAAAAAAAAAAAAAAAAASEAAhAR/9oACAEDAQE/AbJwHo3/xAAaEQABBQEAAAAAAAAAAAAAAAABAAIQESEi/9oACAECAQE/AddyERWT/8QAHhAAAQQBBQAAAAAAAAAAAAAAAQACEiERAyAxQVH/2gAIAQEABj8Ci0xA7TRp36r5RjmSbE4V3s//xAAbEAABBQEBAAAAAAAAAAAAAAABABEhMVFBEP/aAAgBAQABPyGDVOdIDKSEF1RcJR4u5x08I4TCPjQbb1pX/9oADAMBAAIAAwAAABD/AAAA/8QAFxEBAQEBAAAAAAAAAAAAAAAAAREAEP/aAAgBAwEBPxCCq6Anf//EABcRAQADAAAAAAAAAAAAAAAAAAEAEBH/2gAIAQIBAT8QCMi1f//EAB4QAAIDAAIDAQAAAAAAAAAAAAERACExQaFRccHh/9oACAEBAAE/EDBIQtIuupTOEgNi3jZwOimNXHTuAOQywFdQbWuflUNiTKAWwh+w/Zr7E6s//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Sphere Map",
            "title": "Sphere Map",
            "src": "/static/3410f44416fdf2c7199785b649b8784c/603fe/mapping-sphere-cylinder.jpg",
            "srcSet": ["/static/3410f44416fdf2c7199785b649b8784c/75985/mapping-sphere-cylinder.jpg 150w", "/static/3410f44416fdf2c7199785b649b8784c/603fe/mapping-sphere-cylinder.jpg 244w"],
            "sizes": "(max-width: 244px) 100vw, 244px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Sphere Map`}</figcaption>{`
  `}</figure>
    <p>{`极点的位置似乎不太均匀，所以这个方法不是球形均匀的，但是采用分层采样的办法，就基本均匀了。如果从2个球面角度入手，赤道附近总会比两极稀疏。改变image这个投影中x的均匀程度应该可以解决这个问题。这样似乎从数学上来说要精确些，不过可能实现要复杂一些。分层采样似乎是最好的办法？`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      